// Cookies
const appname = "sdhcsimposiumportal";
export const REMEMBER_ME_COOKIE_NAME = `${appname}_remember`;
export const ANALYSE_FUNCTIONS_COOKIE = `${appname}_analyse_fn`;
export const PERSONAL_COOKIE = `${appname}_c`;